import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { uniqueId } from 'lodash-es';

@Component({
  selector: 'app-radio-group-with-label',
  imports: [MatRadioModule, ReactiveFormsModule],
  templateUrl: './radio-group-with-label.component.html',
  styleUrl: './radio-group-with-label.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RadioGroupWithLabelComponent {
  readonly label = input.required<string>();
  readonly options = input.required<{ label: string; value: string }[]>();
  readonly control = input.required<FormControl<unknown>>();
  readonly componentId = uniqueId('radio-group_');
}
